import { useRef } from "react";
import { Link } from "react-router-dom";
import { gsap } from "gsap";
import { useEffect } from "react";

export function Header() {
  const headerRef = useRef(null);

  useEffect(() => {
    const el = headerRef.current;
    if (!el) return;
    const tween = gsap.from(el, {
      y: -100,
      opacity: 0,
      duration: 1,
      ease: "power3.out",
      delay: 2,
    });
    return () => {
      tween.kill();
    };
  }, []);

  return (
    <header ref={headerRef} className="fixed top-0 left-0 right-0 z-50 px-4 pt-4 sm:px-6 sm:pt-5">
      <nav className="mx-auto max-w-4xl flex items-center justify-between">
        {/* Left: Xenotantric Boutique */}
        <Link
          to="/shop"
          className="group relative text-[10px] sm:text-[11px] tracking-[0.25em] uppercase font-light text-white/35 hover:text-white/70 transition-colors duration-700"
        >
          Xenotantric Boutique
          <span className="absolute -bottom-0.5 left-0 w-0 h-px bg-white/20 group-hover:w-full transition-all duration-700" />
        </Link>

        {/* Center: Scarab */}
        <Link
          to="/"
          className="shrink-0 mx-4 sm:mx-6 opacity-40 hover:opacity-70 transition-opacity duration-700"
          aria-label="Home"
        >
          <img
            src="/images/scarab-header.png"
            alt=""
            aria-hidden
            className="h-7 sm:h-9 w-auto invert opacity-80 mix-blend-screen"
          />
        </Link>

        {/* Right: ALI3NP0RN (more prominent) */}
        <Link
          to="/enthea"
          className="group relative text-[10px] sm:text-[11px] tracking-[0.25em] uppercase font-medium text-white/50 hover:text-white/90 transition-colors duration-700"
        >
          ALI3NP0RN
          <span className="absolute -bottom-0.5 right-0 w-0 h-px bg-white/30 group-hover:w-full transition-all duration-700 group-hover:right-auto group-hover:left-0" />
        </Link>
      </nav>
    </header>
  );
}
